import React, { Component } from 'react';

import { withRouter } from "react-router-dom";

import "../design/projecttasks.css";

class TaskListWithCheckbox extends Component {

    constructor(props) {
        super(props);
        this.handleRedirectToTask = this.handleRedirectToTask.bind(this);

        this.state = {
            selectedTasks: []
        };
    }

    handleRedirectToTask(event, taskUUID) {
        event.preventDefault();
        if (event.ctrlKey === true) {
            var win = window.open("/Project/" + this.props.projectUUID + "/Task/" + taskUUID, '_blank');
            win.focus();
        }
        else {
            this.props.history.push("/Project/" + this.props.projectUUID + "/Task/" + taskUUID);
        }
    }

    render() {
        const tasks = this.props.tasks;
        if (!tasks) return null;
        const taskStatuses = this.props.taskStatuses;
        if (taskStatuses.length === 0) return null

        return (
            <div>
                <table>
                    <thead>
                        <tr>
                            <td>Checked</td>
                            <td>Task name</td>
                            <td>Task Status</td>
                        </tr>
                    </thead>
                    <tbody>
                        {tasks.map((task) => (
                            <tr className="tr_hover"
                                key={task.taskUUID}
                            >
                                <td><input type="checkbox" onClick={(event) => { this.props.SelectedTasksCallBack(event, task.taskUuid) }} /></td>
                                <td onClick={(event) => { this.handleRedirectToTask(event, task.taskUuid) }}>{task.taskTitle}</td>
                                <td>{taskStatuses.find(element => element.taskStatusID === task.taskStatus).statusName}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        )
    }
}

export default withRouter(TaskListWithCheckbox);


// WEBPACK FOOTER //
// ./src/components/tasklistWithCheckbox.js